import { useMutation, useQueryClient } from "react-query";
import { restoreStudent } from "api/services/students";
import { EStudentsQueryKeys } from "api/endpoints/students";
import { TStudent } from "types/api/student";
import { TApiError } from "types/api/error";

export const useRestoreStudent = () => {
  const queryClient = useQueryClient();

  return useMutation<TStudent, TApiError, number>(
    (studentId: number) => restoreStudent(studentId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(EStudentsQueryKeys.getArchivedStudents);
        queryClient.invalidateQueries(EStudentsQueryKeys.getStudents);
      },
    }
  );
};
